import { createEvent, createStore } from 'effector';

export type SceneLoadingStatus = 'idle' | 'loading' | 'preview' | 'ready' | 'error';

export type SplatLoadingPhase = 'idle' | 'fetching' | 'initializing' | 'ready';

export type SceneLoadingState = {
  status: SceneLoadingStatus;
  loadedBytes: number;
  totalBytes: number | null;
  splatLoadedBytes: number;
  splatTotalBytes: number | null;
  splatPhase: SplatLoadingPhase;
};

export const sceneLoadingStarted = createEvent();
export const sceneLoadingProgressed = createEvent<{ loadedBytes: number; totalBytes: number | null }>();
export const scenePreviewLoadingFinished = createEvent();
export const sceneLoadingFinished = createEvent();
export const sceneLoadingFailed = createEvent();
export const splatLoadingProgressed = createEvent<{ loadedBytes: number; totalBytes: number | null }>();
export const splatFetchCompleted = createEvent();
export const splatInitCompleted = createEvent();

const initialState: SceneLoadingState = {
  status: 'idle',
  loadedBytes: 0,
  totalBytes: null,
  splatLoadedBytes: 0,
  splatTotalBytes: null,
  splatPhase: 'idle',
};

export const $sceneLoadingState = createStore<SceneLoadingState>(initialState)
  .on(sceneLoadingStarted, () => ({
    status: 'loading',
    loadedBytes: 0,
    totalBytes: null,
    splatLoadedBytes: 0,
    splatTotalBytes: null,
    splatPhase: 'idle',
  }))
  .on(sceneLoadingProgressed, (state, payload) => ({
    ...state,
    loadedBytes: payload.loadedBytes,
    totalBytes: payload.totalBytes,
  }))
  .on(scenePreviewLoadingFinished, (state) => ({
    ...state,
    status: 'preview',
  }))
  .on(splatLoadingProgressed, (state, payload) => ({
    ...state,
    splatLoadedBytes: payload.loadedBytes,
    splatTotalBytes: payload.totalBytes,
    splatPhase: state.splatPhase === 'idle' ? 'fetching' : state.splatPhase,
  }))
  .on(splatFetchCompleted, (state) => ({
    ...state,
    splatPhase: 'initializing',
  }))
  .on(splatInitCompleted, (state) => ({
    ...state,
    splatPhase: 'ready',
  }))
  .on(sceneLoadingFinished, (state) => ({
    ...state,
    status: 'ready',
    loadedBytes: state.totalBytes ?? state.loadedBytes,
  }))
  .on(sceneLoadingFailed, (state) => ({
    ...state,
    status: 'error',
  }));
